import type { IPascoRepository } from "@src/domain/pascos/repository/pasco_repository";
import type { PascoListItemDTO } from "../dto";
import { PascoDtoMapper } from "../mappers/pasco-dto.mapper";

/**
 * Use Case: List All PASCOs
 * Retrieves all PASCO records from the system
 */
export class ListAllPascosUseCase {
    constructor(private readonly pascoRepository: IPascoRepository) { }

    /**
     * Execute the use case
     * @returns Promise<PascoListItemDTO[]> - Array of PASCO DTOs for list display
     */
    async execute(): Promise<PascoListItemDTO[]> {
        const pascos = await this.pascoRepository.listAll();
        return PascoDtoMapper.toListItemDTOArray(pascos);
    }
}
